/**
 * Environment configuration for Exelizer frontend.
 * 
 * Reads from Vite environment variables (VITE_* prefix).
 */

export const config = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT || '',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  awsRegion: import.meta.env.VITE_AWS_REGION || 'us-east-2',
} as const;

/**
 * Validate that required environment variables are set.
 * 
 * Note: In development, we allow API_ENDPOINT to be a placeholder.
 */
export function validateConfig(): void {
  const required = [
    { key: 'VITE_COGNITO_USER_POOL_ID', value: config.cognitoUserPoolId },
    { key: 'VITE_COGNITO_CLIENT_ID', value: config.cognitoClientId },
  ];

  const missing = required.filter(({ value }) => !value);

  if (missing.length > 0) {
    const missingKeys = missing.map(({ key }) => key).join(', ');
    console.error(
      `Missing required environment variables: ${missingKeys}. ` +
      'Please check your .env.local file.'
    );
    // Don't throw in dev - just log the error
    if (import.meta.env.PROD) {
      throw new Error(`Missing required environment variables: ${missingKeys}`);
    }
  }

  // Warn if API endpoint is placeholder
  if (config.apiEndpoint.includes('placeholder')) {
    console.warn('API endpoint is set to placeholder - API calls will fail until API Gateway is deployed');
  }
}

